module.exports = __webpack_public_path__ + "static/media/edit-dark.5983602c.svg";